export const loadImage = async (file: Blob | File): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.addEventListener('load', (event) => {
      const _loadedImageUrl = event.target?.result;
      const image = document.createElement('img');
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      image.src = _loadedImageUrl as string;

      image.addEventListener('load', () => {
        resolve(image);
      });

      image.addEventListener('error', (error) => {
        // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- Need fix
        reject(error);
      });
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
    reader.addEventListener = (error: any) => {
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- Need fix
      reject(error);
    };
  });
